import {AfterViewChecked, Directive, ElementRef, Input, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';

@Directive({
  selector: '[appResponsiveTable]'
})
export class ResponsiveTableDirective implements AfterViewChecked, OnInit, OnDestroy {

  private debounceSub = new Subject<void>();

  @Input()
  debounce = false;

  @Input()
  private disabled = false;

  constructor(private el: ElementRef) {
  }

  public ngOnInit() {
    if (this.disabled) {
      return null;
    }
    if (this.debounce) {
      this.debounceSub.pipe(
        debounceTime(500)
      ).subscribe(() => this.addDataHeaders());
    }
  }

  public ngOnDestroy() {
    if (this.debounceSub) {
      this.debounceSub.unsubscribe();
    }
  }

  public ngAfterViewChecked() {
    if (this.debounce) {
      this.debounceSub.next();
    } else {
      this.addDataHeaders();
    }
  }

  private addDataHeaders() {
    let ths = this.el.nativeElement.getElementsByTagName('th');
    let trs = this.el.nativeElement
      .getElementsByTagName('tbody')
      .item(0)
      .getElementsByTagName('tr');

    for (let i = 0; i < trs.length; i++) {
      let tds = trs.item(i).getElementsByTagName('td');
      for (let j = 0; j < ths.length; j++) {
        if (tds.item(j) != null) {
          tds.item(j).setAttribute('data-header', ths.item(j).innerText);
        }
      }
    }
  }
}
